var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnlocked = function SvgUnlocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#unlocked_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#36B37E",
    d: "M6.462.5c-2.041 0-3.805.847-4.904 2.221C.458 4.095 0 5.876 0 7.798v2.856h2.77V7.798c0-1.457.36-2.603.951-3.346s1.396-1.183 2.74-1.183c1.35 0 2.15.415 2.74 1.154.592.74.953 1.9.953 3.375v1.01h2.77v-1.01c0-1.933-.488-3.732-1.588-5.106S8.5.5 6.462.5m1.846 9.23a2.77 2.77 0 0 0-2.77 2.77v9.23a2.77 2.77 0 0 0 2.77 2.77H21.23A2.77 2.77 0 0 0 24 21.73V12.5a2.77 2.77 0 0 0-2.77-2.77zm6.461 4.616c1.02 0 1.846.826 1.846 1.846a1.83 1.83 0 0 1-.923 1.587v2.106a.925.925 0 0 1-.923.923.925.925 0 0 1-.923-.923v-2.106a1.83 1.83 0 0 1-.923-1.587c0-1.02.826-1.846 1.846-1.846"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "unlocked_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h24v24H0z"
  })))));
};
export default SvgUnlocked;